import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAWIOWt6qvDXfIeLNoBW6n-A46l0g6KhbU",
  authDomain: "arcblogger.firebaseapp.com",
  databaseURL: "https://arcblogger-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "arcblogger",
  storageBucket: "arcblogger.appspot.com",
  messagingSenderId: "439474124188",
  appId: "1:439474124188:web:3276a477943238074c0459",
  measurementId: "G-Y2L1RZMQZV"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();